module.exports = __webpack_public_path__ + "static/img/b2.5c75329.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/b2.png
// module id = oMqn
// module chunks = 0